import { AttendanceStatus } from '../types';

/**
 * How each attendance status reads — its letter, name and colours. One
 * source for the attendance grid, its legend and the attendance PDFs, so
 * screen and paper always agree.
 */
export const STATUS_VISUAL: Record<AttendanceStatus, { text: string; label: string; bg: string; border: string }> = {
  [AttendanceStatus.PRESENT]:        { text: 'P',  label: 'Present',       bg: '#22c55e', border: '#16a34a' },
  [AttendanceStatus.LATE]:           { text: 'L',  label: 'Late',          bg: '#f59e0b', border: '#d97706' },
  [AttendanceStatus.HALF_DAY]:       { text: 'H',  label: 'Half Day',      bg: '#3b82f6', border: '#2563eb' },
  [AttendanceStatus.ABSENT]:         { text: 'A',  label: 'Absent',        bg: '#ef4444', border: '#dc2626' },
  [AttendanceStatus.SCHEDULED_OFF]:  { text: 'SO', label: 'Weekly Off',    bg: '#8b5cf6', border: '#7c3aed' },
  [AttendanceStatus.NOT_SCHEDULED]:  { text: 'NS', label: 'Not Scheduled', bg: '#64748b', border: '#475569' },
  [AttendanceStatus.LEAVE]:          { text: 'LE', label: 'Leave',         bg: '#06b6d4', border: '#0891b2' },
  [AttendanceStatus.HOLIDAY]:        { text: 'HO', label: 'Holiday',       bg: '#ea580c', border: '#c2410c' },
};

/** Statuses that carry informed / uninformed. */
export const INFO_INDICATOR_STATUSES = new Set<AttendanceStatus>([
  AttendanceStatus.LATE,
  AttendanceStatus.HALF_DAY,
  AttendanceStatus.ABSENT,
]);

/** Days that aren't school days — they don't count as working days. */
export const NON_WORKING_STATUSES = new Set<AttendanceStatus>([
  AttendanceStatus.SCHEDULED_OFF,
  AttendanceStatus.NOT_SCHEDULED,
  AttendanceStatus.HOLIDAY,
]);

/** The informed / uninformed marker colours. */
export const INFO_DOT = { informed: '#2563eb', uninformed: '#ef4444' } as const;

/** An attendance rate's colour — green is fine, teal and blue are fair, amber needs attention, red is alarming. Screen and PDF alike. */
export const attendanceRateColor = (pct: number): string =>
  (pct >= 80 ? '#16a34a' : pct >= 65 ? '#0f766e' : pct >= 50 ? '#0369a1' : pct >= 33 ? '#f59e0b' : '#dc2626');
